import React, { useState } from "react";
import styled from "styled-components";
import AdminSider from "../../components/AdminPanel/AdminSider";
import Dashboard from "../../components/AdminPanel/Dashboard";
import Request from "../../components/AdminPanel/adminRequest";
import RidesInfo from "../../components/AdminPanel/ridetab";
import Customers from "../../components/AdminPanel/customers";
import Report from "../../components/AdminPanel/adminReport";
import BannedUsers from "../../components/AdminPanel/bannedUsers";
import WithdrawalRequests from "../../components/AdminPanel/withdrawals";
import Bookings from "../../components/AdminPanel/bookings";
import Route from "../../components/AdminPanel/PopularRoutes";
import Analytics from "../../components/AdminPanel/analytics/Analytics";
import Admins from "../../components/AdminPanel/admins";
import RideWishes from "../../components/AdminPanel/rideWishes";
import { COLORS } from "../../assets/colors";

function AdminPage() {
  const [currentItem, setCurrentItem] = useState("dashboard");
  const handleItem = (item) => {
    setCurrentItem(item);
  };
  return (
    <AdminWrapper>
      <div className="sider">
        <AdminSider handleItem={handleItem} currentItem={currentItem} />
      </div>
      <div className="content">
        {currentItem === "dashboard" && <Dashboard />}
        {currentItem === "requests" && <Request />}
        {currentItem === "rides" && <RidesInfo />}
        {currentItem === "customers" && <Customers />}
        {currentItem === "reports" && <Report />}
        {currentItem === "banned" && <BannedUsers />}
        {currentItem === "withdrawals" && <WithdrawalRequests />}
        {currentItem === "bookings" && <Bookings />}
        {currentItem === "route" && <Route />}
        {currentItem === "analytics" && <Analytics />}
        {currentItem === "rideWishes" && <RideWishes />}
        {currentItem === "admins" && <Admins />}
      </div>
    </AdminWrapper>
  );
}

export default AdminPage;

const AdminWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: ${COLORS.adminBg};
  overflow: hidden;

  .sider {
    width: 260px;
    background-color: ${COLORS.adminSidebar};
    height: 100vh;
    flex-shrink: 0;
    z-index: 100;
  }

  .content {
    flex-grow: 1;
    overflow-y: auto;
    padding: 2rem;
    height: 100vh;
    background-color: ${COLORS.adminBg};
  }

  @media (max-width: 1024px) {
    .sider {
      width: 80px;
      .logo-text, .label {
        display: none;
      }
      .logo-section {
        padding: 1.5rem 0.5rem;
        justify-content: center;
      }
      .main {
        padding: 1rem 0.5rem;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    .sider {
      width: 100%;
      height: auto;
      position: relative;
    }
    .content {
      height: auto;
      padding: 1rem;
    }
  }
`;
